import { render } from "./MenuTableSearch.vue?vue&type=template&id=ed967120"
import script from "./MenuTableSearch.vue?vue&type=script&lang=js"
export * from "./MenuTableSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__